


















import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator'
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css'

@Component({})
export default class ImagePickerEditor extends Vue {
    @Prop({default: 240}) width!: number;
    @Prop({default: 300}) height!: number;
    @Prop() value!: string;
    @Prop({default: true}) showButtons!: boolean;
    @Prop({default: true}) showPreview!: boolean;
    @Prop({default: 'sm'}) dialogSize!: 'sm|lg|xl';
    image = '';
    dialogVisible = false;
    cropper: Cropper;

    created() {
        this.image = this.value;
    }

    @Watch('value')
    onValueChanged(value: string) {
        this.image = value;
    }

    select() {
        (<HTMLElement>this.$refs['file']).click();
    }

    loadFile(e) {
        const files = e.target.files;
        if (files.length == 1) {
            const file = files[0];
            const reader = new FileReader();
            reader.onload = (f) => {
                this.image = (<any>f.target).result;
                this.dialogVisible = true;
            };
            reader.readAsDataURL(file);
        }
    }

    modalOpened() {
        this.cropper = new Cropper(<HTMLImageElement>this.$refs['image'], {
            aspectRatio: this.width / this.height,
            responsive: false,
            modal: true,
            viewMode: 3
        });
    }

    accept() {
        this.image = this.cropper.getCroppedCanvas({width: this.width, height: this.height}).toDataURL();
        this.dialogVisible = false;
        this.input(this.image);
    }

    @Emit() input(value: string) {
    }
}
